// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset -------------------------------------------------------------------- */
* {
  margin: 0;
  padding: 0;
}

body {
  font-size: 14px;
}

/* OPPS --------------------------------------------------------------------- */
ion-content {
  --background: white;
}

h3 {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.opps {
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 45px;
  overflow: hidden;
  font-family: "Open Sans", sans-serif;
  color: black;
  background: white;
}

.opps-reminder {
  position: relative;
  top: -1px;
  padding: 9px 0 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: var(--ion-color-primary);
  background: white;
}

.opps-info {
  margin-top: 26px;
  position: relative;
}

.opps-info:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.opps-brand {
  float: left;
}

.opps-brand img {
  max-width: 100%;
  margin-top: 2px;
}

.opps-ammount {
  width: 100%;
  float: right;
}

.opps-ammount h2 {
  font-size: 36px;
  color: #000000;
  line-height: 24px;
  margin-bottom: 15px;
}

.opps-ammount h2 sup {
  font-size: 12px;
  position: relative;
  top: -2px;
}

.opps-ammount p {
  font-size: 13px;
  font-weight: 800;
}

.opps-reference {
  margin-top: 14px;
}

h1 {
  font-size: 27px;
  color: #000000;
  text-align: center;
  margin-top: -1px;
  padding: 6px 0 7px;
  border: 1px solid #b0afb5;
  border-radius: 4px;
  background: #f8f9fa;
}

.opps-instructions {
  margin: 32px -45px 0;
  padding: 32px 45px 45px;
  border-top: 1px solid #b0afb5;
  background: #f8f9fa;
}

ol {
  margin: 17px 0 0 16px;
}

li + li {
  margin-top: 10px;
  color: #000000;
}

a {
  color: #1155cc;
}

.opps-footnote {
  margin-top: 22px;
  padding: 22px 20 24px;
  color: #108f30;
  text-align: center;
  border: 1px solid #108f30;
  border-radius: 4px;
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/oxxo-pay/oxxo-pay.component.scss"],"names":[],"mappings":"AAAA,+EAAA;AACA;EAAM,SAAA;EAAU,UAAA;AAGhB;;AAFA;EAAO,eAAA;AAMP;;AAJA,+EAAA;AACA;EACE,mBAAA;AAOF;;AALA;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACC,+BAAA;AAQF;;AALA;EACC,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EAEA,gBAAA;EAEA,oCAAA;EACA,YAAA;EACC,iBAAA;AAMF;;AAHA;EACC,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACC,gBAAA;EACD,yBAAA;EACA,kBAAA;EACA,+BAAA;EACA,iBAAA;AAMD;;AAHA;EACC,gBAAA;EACA,kBAAA;AAMD;;AAHA;EACC,kBAAA;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAML;;AAFA;EAEC,WAAA;AAID;;AADA;EACC,eAAA;EACA,eAAA;AAID;;AADA;EACC,WAAA;EACA,YAAA;AAID;;AADA;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAID;;AADA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;AAID;;AADA;EACC,eAAA;EACA,gBAAA;AAID;;AADA;EACC,gBAAA;AAID;;AADA;EACC,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAID;;AADA;EACC,oBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AAID;;AADA;EACC,qBAAA;AAID;;AADA;EACC,gBAAA;EACA,cAAA;AAID;;AADA;EACC,cAAA;AAID;;AADA;EACC,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAID","sourcesContent":["/* Reset -------------------------------------------------------------------- */\n* \t { margin: 0;padding: 0; }\nbody { font-size: 14px; }\n\n/* OPPS --------------------------------------------------------------------- */\nion-content{\n  --background: white;\n}\nh3 {\n\tmargin-bottom: 10px;\n\tfont-size: 15px;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n  color: var(--ion-color-primary);\n}\n\n.opps {\n\twidth: 100%;\n\tborder-radius: 4px;\n\tbox-sizing: border-box;\n\tpadding: 0 45px;\n\t// margin: 40px auto;\n\toverflow: hidden;\n\t// border: 1px solid #b0afb5;\n\tfont-family: 'Open Sans', sans-serif;\n\tcolor: black;\n  background: white;\n}\n\n.opps-reminder {\n\tposition: relative;\n\ttop: -1px;\n\tpadding: 9px 0 10px;\n\tfont-size: 11px;\n  font-weight: 700;\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tcolor: var(--ion-color-primary);\n\tbackground: white;\n}\n\n.opps-info {\n\tmargin-top: 26px;\n\tposition: relative;\n}\n\n.opps-info:after {\n\tvisibility: hidden;\n     display: block;\n     font-size: 0;\n     content: \" \";\n     clear: both;\n     height: 0;\n\n}\n\n.opps-brand {\n\t//width: 35%;\n\tfloat: left;\n}\n\n.opps-brand img {\n\tmax-width: 100%;\n\tmargin-top: 2px;\n}\n\n.opps-ammount {\n\twidth: 100%;\n\tfloat: right;\n}\n\n.opps-ammount h2 {\n\tfont-size: 36px;\n\tcolor: #000000;\n\tline-height: 24px;\n\tmargin-bottom: 15px;\n}\n\n.opps-ammount h2 sup {\n\tfont-size: 12px;\n\tposition: relative;\n\ttop: -2px\n}\n\n.opps-ammount p {\n\tfont-size: 13px;\n\tfont-weight: 800;\n}\n\n.opps-reference {\n\tmargin-top: 14px;\n}\n\nh1 {\n\tfont-size: 27px;\n\tcolor: #000000;\n\ttext-align: center;\n\tmargin-top: -1px;\n\tpadding: 6px 0 7px;\n\tborder: 1px solid #b0afb5;\n\tborder-radius: 4px;\n\tbackground: #f8f9fa;\n}\n\n.opps-instructions {\n\tmargin: 32px -45px 0;\n\tpadding: 32px 45px 45px;\n\tborder-top: 1px solid #b0afb5;\n\tbackground: #f8f9fa;\n}\n\nol {\n\tmargin: 17px 0 0 16px;\n}\n\nli + li {\n\tmargin-top: 10px;\n\tcolor: #000000;\n}\n\na {\n\tcolor: #1155cc;\n}\n\n.opps-footnote {\n\tmargin-top: 22px;\n\tpadding: 22px 20 24px;\n\tcolor: #108f30;\n\ttext-align: center;\n\tborder: 1px solid #108f30;\n\tborder-radius: 4px;\n\tbackground: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
